import {
  Estimate,
  Quote,
} from '../../../../../shared/models/vendor-order.model';

export type QuoteType = 'Standard' | 'Rushed';

export interface QuotePdfOption {
  quoteType: QuoteType;
  deliveryDate: string;
  totalCost: number;
  currency: string;
}

export function getAvailableQuoteTypes(
  estimate: Estimate,
  includeFallback = false,
): QuoteType[] {
  const types: QuoteType[] = [];
  if (estimate.quote?.normal) {
    types.push('Standard');
  }
  if (estimate.quote?.rushed) {
    types.push('Rushed');
  }
  if (!types.length && includeFallback) {
    types.push('Standard');
  }
  return types;
}

export function getQuoteForType(
  estimate: Estimate,
  quoteType: QuoteType,
): Quote | null {
  if (quoteType === 'Standard') {
    return estimate.quote?.normal ?? null;
  }
  return estimate.quote?.rushed ?? null;
}

export function getDeliveryDateForQuoteType(
  estimate: Estimate,
  quoteType: QuoteType,
): Date | string | undefined {
  if (estimate.jobStatus === 'AWAITING_VENDOR_SELECTION') {
    const businessDays = getBusinessDaysForQuoteType(estimate, quoteType);

    if (
      typeof businessDays === 'number' &&
      Number.isFinite(businessDays) &&
      businessDays >= 0
    ) {
      return addBusinessDays(new Date(), businessDays);
    }
  }

  if (quoteType === 'Standard') {
    return (
      estimate.quote?.normal?.deliveryDate ??
      estimate.estimatedDeliveryDates?.normal?.estimatedDeliveryDate ??
      estimate.deadline
    );
  }
  return (
    estimate.quote?.rushed?.deliveryDate ??
    estimate.estimatedDeliveryDates?.rushed?.estimatedDeliveryDate ??
    estimate.deadline
  );
}

function getBusinessDaysForQuoteType(
  estimate: Estimate,
  quoteType: QuoteType,
): number | undefined {
  if (quoteType === 'Standard') {
    return estimate.quote?.normal?.businessDays;
  }
  return estimate.quote?.rushed?.businessDays;
}

function addBusinessDays(startDate: Date, businessDays: number): Date {
  const result = new Date(startDate);
  result.setHours(0, 0, 0, 0);

  let remainingBusinessDays = Math.trunc(businessDays);
  while (remainingBusinessDays > 0) {
    result.setDate(result.getDate() + 1);
    const dayOfWeek = result.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      remainingBusinessDays -= 1;
    }
  }

  return result;
}
